export const VIDEOMAP = {
  WOMEN: {
    AVERY: `https://nutrafol.com/media/video_storage/Avery_240626.mp4`,
    AVERY_MOBILE: `https://nutrafol.com/media/video_storage/Avery_Mobile_240626.mp4`,
    AISHA: `https://nutrafol.com/media/video_storage/Aisha_240626.mp4`,
    AISHA_MOBILE: `https://nutrafol.com/media/video_storage/Aisha_Mobile_240626.mp4`,
    LISA: `https://nutrafol.com/media/video_storage/Lisa_Testimonial_X1_PDP_Desktop_R1.mp4`,
    LISA_MOBILE: `https://nutrafol.com/media/video_storage/Lisa_Testimonial_X1_PDP_Mobile_R1.mp4`,
    SHEILA: `https://nutrafol.com/media/video_storage/Com_PDP_Masterbrand_Testimonial_Sheila_desktop.mp4`,
    SHEILA_MOBILE: `https://nutrafol.com/media/video_storage/Com_PDP_Masterbrand_Testimonial_Sheila_mobile.mp4`,
  },
  VEGAN: {
    BIANCA: `https://nutrafol.com/media/video_storage/PDPTestimonials_Desktop_Vegan_Bianca_240626.mp4`,
    BIANCA_MOBILE: `https://nutrafol.com/media/video_storage/PDPTestimonials_Mobile_Vegan_Bianca_240626.mp4`,
    KRYSTAL: `https://nutrafol.com/media/video_storage/Vegan_Desktop_240626.mp4`,
    KRYSTAL_MOBILE: `https://nutrafol.com/media/video_storage/Vegan_Mobile_240626.mp4`,
  },
  BALANCE: {
    KAREN: `https://nutrafol.com/media/video_storage/KarenRochelle_Testimonial_240626.mp4`,
    KAREN_MOBILE: `https://nutrafol.com/media/video_storage/KarenRochelle_Testimonial_Mobile_240626.mp4`,
    KATHY: `https://nutrafol.com/media/video_storage/Com_PDP_Masterbrand_Testimonial_KathyAnn_desktop.mp4`,
    KATHY_MOBILE: `https://nutrafol.com/media/video_storage/Com_PDP_Masterbrand_Testimonial_KathyAnn_mobile.mp4`,
    STACEY: `https://nutrafol.com/media/video_storage/Stacey_Testimonial_240626.mp4`,
    STACEY_MOBILE: `https://nutrafol.com/media/video_storage/Stacey_Testimonial_Mobile_240626.mp4`,
  },
  POSTPARTUM: {
    GIGI: `https://nutrafol.com/media/video_storage/Gigi_Desktop_240624.mp4`,
    GIGI_MOBILE: `https://nutrafol.com/media/video_storage/Gigi_Mobile240624.mp4`,
    SAMANTHA: `https://nutrafol.com/media/video_storage/Com_PDP_Masterbrand_Testimonial_Samantha_desktop.mp4`,
    SAMANTHA_MOBILE: `https://nutrafol.com/media/video_storage/Com_PDP_Masterbrand_Testimonial_Samantha_mobile.mp4`,
    JOJO: `https://nutrafol.com/media/video_storage/Jojo_240624.mp4`,
    JOJO_MOBILE: `https://nutrafol.com/media/video_storage/Jojo_Mobile_240624.mp4`,
    MEGAN: `https://nutrafol.com/media/video_storage/pdp-postpartum-influencer.mp4`,
    MEGAN_MOBILE: `https://nutrafol.com/media/video_storage/pdp-postpartum-influencer-mobile.mp4`,
  },
  MEN: {
    SETH: `https://nutrafol.com/media/video_storage/Seth_Desktop_240626.mp4`,
    KYLE: `https://nutrafol.com/media/video_storage/Kyle_Desktop_240626.mp4`,
    JOSH: `https://nutrafol.com/media/video_storage/Josh_Desktop_240626.mp4`,
    AARON: `https://nutrafol.com/media/video_storage/AaronVeasley_Testimonial_X1_PDP_Desktop_Color_R2.mp4`,
    AARON_MOBILE: `https://nutrafol.com/media/video_storage/AaronVeasley_Testimonial_X1_PDP_Mobile_Color_R2.mp4`,
    STEPHEN: `https://nutrafol.com/media/video_storage/pdp-men-influencer.mp4`,
    STEPHEN_MOBILE: `https://nutrafol.com/media/video_storage/pdp-men-influencer-mobile.mp4`,
    JACOB: `https://nutrafol.com/media/video_storage/Com_PDP_Men_Testimonial_Jacob_desktop.mp4`,
    JACOB_MOBILE: `https://nutrafol.com/media/video_storage/Com_PDP_Men_Testimonial_Jacob_mobile.mp4`,
  },
}
